import { useGetIndividualResultQuery } from '../state/api';
import IndividualResultTable from './individual-result-table';

interface IndividualResultTableContainerProps {
  compID: string | undefined;
  title?: string;
  eventDate?: string;
}

const IndividualResultTableContainer = ({ compID }: IndividualResultTableContainerProps) => {
  const { data: results = [] } = useGetIndividualResultQuery(compID!, {
    skip: compID === undefined,
  });

  return <IndividualResultTable results={results} />;
};

export default IndividualResultTableContainer;
